












































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import CheckIcon from 'frontend/components/icons/CheckIcon.vue';
import Button from 'frontend/components/Button.vue';

import { track } from 'frontend/utils/analytics';
import { postData } from 'frontend/utils/ajax';
import { TrackingProperties } from 'frontend/views/lessons/lesson/Lesson.vue';

const EMAIL_ME_AX_EVENT: string = 'clicked_continue_on_desktop_email_link';
const BROWSE_ALL_COURSES_AX_EVENT: string = 'clicked_browse_all_courses';

const components = { Button, CheckIcon };

interface EmailParams {
  [key: string]: number | string | null;
}

@Component({ components })
export default class DesktopOnlyModal extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly shouldLockScrollOnMount!: boolean;
  @Prop({ type: Function }) private trackingProperties!: () => TrackingProperties;
  @Prop({ type: Boolean, default: false }) private isNative!: boolean;
  @Prop({ type: String, default: null }) private courseSlug!: string;

  isHidden: boolean = false;
  hasClickedEmailCta: boolean = false;
  isDrawerClosed: boolean = false;

  mounted() {
    if (this.shouldLockScrollOnMount) {
      document.body.classList.add('no-scroll');
    }
  }

  private async emailMeALink(e: MouseEvent) {
    this.trackCTAClick(EMAIL_ME_AX_EVENT);
    await this.triggerEmailSend();
    this.hasClickedEmailCta = true;
  }

  private goToCourseIndex() {
    this.trackCTAClick(BROWSE_ALL_COURSES_AX_EVENT);
    this.$emit('onBackToAllCourses');
  }

  private trackCTAClick(eventName: string) {
    const eventStream: string = this.isNative ? 'mobile_native_ui' : 'ui';

    track(eventStream, {
      action: 'click',
      element_type: 'button',
      element_id: eventName,
    });
  }

  private cleanParams(params: EmailParams): EmailParams {
    const cleanedParams: EmailParams = {};
    Object.keys(params).forEach(key => {
      if (params[key]) cleanedParams[key] = params[key];
    });

    return cleanedParams;
  }

  private async triggerEmailSend() {
    const { course_version_id: courseVersionId } = this.trackingProperties();
    const courseUrl = new URL(
      `${document.location.protocol}//${document.location.host}/courses/${this.courseSlug}`,
    ).href;
    const params: EmailParams = {
      course_url: courseUrl ?? null,
      course_version_id: courseVersionId ?? null,
    };

    await postData('/api/v3/trigger-mobile-to-desktop-transition-email/', this.cleanParams(params));
  }
}
